type Translate = (key: string) => string;

export const getQuickLinks = (t: Translate) => [
  { slug: 'know-your-business', label: t('Business verification') },
  { slug: 'ultimate-beneficial-owner', label: t('Ownership & UBOs') },
  { slug: 'business-credit-report', label: t('Company credit reports') },
  { slug: 'company-register', label: t('Company registers') },
];

export const getEditorialPicks = (t: Translate) => [
  {
    slug: 'business-credit-report',
    eyebrow: t('Check company credit'),
    title: t('What Is a Business Credit Report? How to Check and Read It'),
    description: t('What a business credit report contains and how to read the evidence.'),
  },
  {
    slug: 'know-your-business',
    eyebrow: t('Verify a business'),
    title: t('What Is KYB? Know Your Business Verification Explained'),
    description: t('Understand KYB identity checks and the questions they leave open.'),
  },
  {
    slug: 'ultimate-beneficial-owner',
    eyebrow: t('Understand ownership'),
    title: t('What Is a UBO? Ultimate Beneficial Owner Explained'),
    description: t('Follow the distinction between direct shareholders and ultimate control.'),
  },
  {
    slug: 'company-register',
    eyebrow: t('Search official records'),
    title: t('Company Register: What It Is and How to Search'),
    description: t('Start with the source, jurisdiction and legal entity.'),
  },
  {
    slug: 'entity-resolution',
    eyebrow: t('Match company records'),
    title: t('Entity Resolution: Meaning, Matching and Examples'),
    description: t('Keep similar names from becoming the wrong company match.'),
  },
  {
    slug: 'company-data-api',
    eyebrow: t('Work with company data'),
    title: t('Company Data API: How It Works and What to Check'),
    description: t('Understand source coverage, identifiers and reliable data delivery.'),
  },
];

export const getKybSteps = (t: Translate) => [
  t('Identify the legal entity'),
  t('Understand ownership & control'),
  t('Assess the relationship'),
  t('Keep the evidence current'),
];
